import React, {useContext} from 'react'
import ConfigWrapper from './ConfigWrapper';
import CacheBuster from 'react-cache-buster';
import {version} from '../package.json';
import { CircularProgress } from '@mui/material';
import { init } from '@fullstory/browser';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ConfigContext } from './Store/ConfigContext'

init({ orgId: 'o-1PT2R4-na1', namespace: 'FS' }, ({ sessionUrl }) =>
  console.log(`Started session`),
);

export default function App() {
  const { theme } = useContext(ConfigContext)

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={true}
      isVerboseMode={false}
      loadingComponent={<CircularProgress/>}
    >
      <MuiThemeProvider theme={theme}>
          <ConfigWrapper/>
      </MuiThemeProvider>
    </CacheBuster>
  )
}
